import { FC, useEffect } from "react";
import { useAppSelector } from "../hooks/ReduxHooks";
import { Navigate, Outlet } from "react-router-dom";
import AdminHeader from "../components/UI/admin-header/AdminHeader";

interface IAdminRoutesProps {}

const AdminRoutes: FC<IAdminRoutesProps> = () => {
  const operator = useAppSelector((state) => state.user.operator);
  useEffect(() => {
    console.log(operator);
  }, [operator]);
  return operator && operator.is_admin ? (
    <Outlet />
  ) : (
    <Navigate to="/inn-check" />
  );
};

export default AdminRoutes;
